var $ = require('jQuery');
var MergeFields = require('../../lib/merge-fields.js');

module.exports = function() {
	$('.inputContentBlockKey').change(function () {
		var key = $(this).val();

		$.ajax({
			type: "GET",
			url: "/content-block/type/" + key,
			dataType: "json"
		}).success(function (data) {
			if (data.type == 'info-box') {
				$('.content-block-visibility').show();
			} else {
				$('.content-block-visibility').hide();
			}
		});
	});

    // Merge fields
    var mergeFields = new MergeFields();
    mergeFields.setup('merge-fields', 'textarea[id="content"]');

    var displayMergeFields = function () {
        var trigger = $('#inputContentBlockKey').val();

        $("[id$=-merge-fields]").attr('class', 'hidden');

        if (trigger) {
            $("[id^=" + trigger + "]").toggleClass('hidden');
        }
    };

    $('#inputContentBlockKey').on('change', displayMergeFields);

    displayMergeFields();
};
